import { AiCreateArtworkPattern } from '~/graphqls/types'

import { useAtom } from 'jotai'
import { AdvanceComp } from '../ai-form/AdvanceComp'
import { CharacterComp } from '../ai-form/CharacterComp'
import { CreativityDegreeComp } from '../ai-form/CreativityDegreeComp'
import { LabInitImageComp } from '../ai-form/LabInitImageComp'
import { LabModelCodeComp } from '../ai-form/LabModelCodeComp'
import { ModelFusionComp } from '../ai-form/ModelFusionComp'
import { PreProcessComp } from '../ai-form/PreProcessComp'
import { PreProcessSwitchComp } from '../ai-form/PreProcessSwitchComp'
import { PrefineComp } from '../ai-form/PrefineComp'
import { PromptComp } from '../ai-form/PromptComp'
import { UcPropmtComp } from '../ai-form/UcPropmtComp'
import { VipParamsComp } from '../ai-form/VipParamsComp'
import { hasAdvanceAtom, patternAtom } from '../ai-form/atom'

export const ControlnetFormContent = () => {
  /** 高级选项 */
  const [hasAdvance] = useAtom(hasAdvanceAtom)
  const [pattern] = useAtom(patternAtom)

  return (
    <>
      {/** 参考图 */}
      <LabInitImageComp />

      {/* scribble 预处理方式 */}
      {[AiCreateArtworkPattern.SCRIBBLE].includes(pattern) && (
        <PreProcessComp />
      )}

      {/* controlnet 除 scribble 外的预处理方式 */}
      {pattern !== AiCreateArtworkPattern.SCRIBBLE && <PreProcessSwitchComp />}

      {/* 模型主题 */}
      <LabModelCodeComp />

      {/* 画面描述 */}
      <PromptComp />

      {/** 图像精绘 */}
      <PrefineComp />

      {/** 高级设置 */}
      <AdvanceComp />

      {hasAdvance && (
        <>
          {/* 负面描述 */}
          <UcPropmtComp />

          {/** 角色同人 */}
          <CharacterComp />

          {/** 融合模型 */}
          <ModelFusionComp />

          {/* 创意度 */}
          <CreativityDegreeComp />

          {/* 会员专享参数 */}
          <VipParamsComp />
        </>
      )}
    </>
  )
}
